/* Optional cutouts must never prevent the uploaded product photo from appearing. */
(() => {
  const cardSelector = '.bw-product-card';
  const primarySelector = '.bw-product-card__image--primary';
  function recoverPrimary(image) {
    const visual = image.closest('.bw-product-card__visual');
    const fallback = image.dataset.bwFallbackSrc || visual?.dataset.bwBackupSrc;
    if (fallback) {
      const isFirstUpload = Boolean(image.dataset.bwFallbackSrc);
      const srcset = isFirstUpload ? image.dataset.bwFallbackSrcset : '';
      // Clear before assigning URLs: a failed fallback cannot retry indefinitely.
      delete image.dataset.bwFallbackSrc;
      delete image.dataset.bwFallbackSrcset;
      if (!isFirstUpload) delete visual.dataset.bwBackupSrc;
      visual?.classList.add('bw-product-card__visual--uploaded');
      if (srcset) image.srcset = srcset;
      else image.removeAttribute('srcset');
      image.src = fallback;
    }
  }

  function inspectCard(card) {
    const primary = card.querySelector(primarySelector);
    if (primary?.complete && primary.naturalWidth === 0) recoverPrimary(primary);
  }

  function inspectWithin(root) {
    if (root.matches?.(cardSelector)) inspectCard(root);
    root.querySelectorAll?.(cardSelector).forEach(inspectCard);
  }

  function onImageEvent(event) {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;
    const card = image.closest(cardSelector);
    if (!card) return;
    if (image.matches(primarySelector)) recoverPrimary(image);
  }

  // Capture image events (they do not bubble), including cards added by filters
  // and recommendations. Inspect cached failures that happened before this script.
  document.addEventListener('error', onImageEvent, true);
  inspectWithin(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) inspectWithin(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
